// cloudknit款式
export const cloudKnitReg = /^(?:https?:\/\/)?(?:[\w-]+\.)?cloudknit\.cn(?:\/project)?\/(\w+)$/;
export const oldCloudKnitReg = /^(?:https?:\/\/)?(?:[\w-]+)\.?cloudknit\.cn\/\?pathId=([a-zA-Z0-9]+)/;

// 凌迪廓形短链接
export const style3dRShortRegV3 = /(?:https?:\/\/)?(?:[\w-]+\.)?style3d\.com(?:\/sl)?\/r\/(\w+)/;

// cloudknit面料
export const cloudKnitFabricReg = /^(?:https?:\/\/)?(?:[\w-]+\.)?cloudknit\.cn\/fabric\/([\w-]+)$/;

// 凌迪面料
export const style3dReg = /(?:https?:\/\/)?(?:[\w-]+\.)?style3d\.com\/fabric\/(\w+)/;
// 凌迪面料短链接
export const style3dUShortRegV3 = /(?:https?:\/\/)?(?:[\w-]+\.)?style3d\.com\/(?:api_v2\/|sl\/)?u\/(\w+)/;
